<template>
  <div>
    <a-form layout="inline">
      <a-row :gutter="12" class="searchManagement">
        <a-col :md="4" :sm="20" class="searchInput">
          <a-input placeholder="附件" v-model="searchModel.anln1" />
        </a-col>
        <a-col :md="4" :sm="20" class="searchInput">
          <a-input placeholder="电子原文" v-model="searchModel.anname" />
        </a-col>
        <a-col :md="4" :sm="24" class="searchInput">
          <a-button type="primary" @click="search" style="margin-right: 12px">查询</a-button>
          <a-button @click="clearSearch">重置</a-button>
        </a-col>
      </a-row>
    </a-form>
    <a-table
      class="table"
      bordered
      :columns="tableData.columns"
      :data-source="tableData.data"
      :pagination="tableData.pagination"
    >
      <template slot="actions" slot-scope="text, record">
        <a href="javascript:;">详情</a>
      </template>
    </a-table>
  </div>
</template>
<script>
export default {
  data () {
    return {
      tableData: {
        columns: [
          {
            title: '序号',
            customRender: (text, record, index) => {
              return index + 1
            },
            align: 'center',
            width: 60
          },
          {
            title: '设备名称',
            dataIndex: 'name',
            align: 'left',
            width: '20%'
          },
          {
            title: '设备编号',
            dataIndex: 'class',
            align: 'left',
            width: '20%'
          },
          {
            title: '设备类别',
            dataIndex: 'person',
            align: 'left',
            width: '20%'
          },
          {
            title: '规格型号',
            dataIndex: 'time',
            align: 'left',
            width: '20%'
          },
          {
            title: '购置价值',
            dataIndex: 'time2',
            align: 'left',
            width: '20%'
          },
          {
            title: '操作',
            scopedSlots: {
              customRender: 'actions'
            },
            align: 'left',
            width: '20%'
          }
        ],
        data: [],
        pagination: {
          pageNum: 1,
          pageSize: 10,
          total: 0,
          pageSizeOptions: ['10', '20', '30', '40', '9999'],
          showSizeChanger: true,
          showQuickJumper: true
        }
      },
      analogData: [],
      searchModel: {}
    }
  },
  mounted () {
    this.getTableData()
  },
  methods: {
    getTableData () {
      for (let i = 0; i < 99; i++) {
        this.analogData.push(
          {
            id: 1 + `a${i}`,
            name: '1010-PCWZ-2209035N五环',
            class: '10111111110001',
            person: '管道',
            time: 'xxxxxx',
            time2: 'xxxxxx'
          }
        )
      }
      this.tableData.data = this.analogData
    },
    // 查询
    search () {
      console.log(this.searchModel)
    },
    clearSearch () {
      this.searchModel = {}
      console.log(this.searchModel)
    },
    // 文件下载
    handleDownload () {},
    // 文件预览
    handlePreview () {}
  },
}
</script>

<style lang="less" scoped>
.table {
  margin-left: -1px;
  margin-right: -1px;
  /deep/.ant-table-thead > tr > th {
    background: rgba(8, 64, 159, 0.1);
  }
  /deep/ .ant-table-tbody > tr > td {
    padding: 10px;
  }
}
.searchManagement {
  margin: 0 !important;
  .searchInput {
    padding: 10px 0 10px 12px !important;
  }
}
</style>
